import React from 'react';

import CodeMirrorPreview from '@dashboard/components/CodeMirror/CodeMirrorPreview';
import { useWorkflowEventQuery } from '@dashboard/generated/wp/platform';

type Props = {
  id: string;
};
export default function InputPreview({ id }: Props) {
  const { data } = useWorkflowEventQuery({ variables: { id } });
  const event = data?.WorkflowEvent;
  if (!event) {
    return null;
  }

  const value = JSON.stringify(event.variables, null, '  ');
  return <CodeMirrorPreview language="JSON" value={value} />;
}
